import { render, staticRenderFns } from "./MagentoAuth.vue?vue&type=template&id=7747e735&lang=pug"
import script from "./MagentoAuth.vue?vue&type=script&lang=js"
export * from "./MagentoAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports